import React from "react";

const StatsSummaryRow = ({ stats }) => {
  if (!Array.isArray(stats)) return null;
  return (
    <section className="tme-nutrition-analysis__stats-row">
      {stats.map((s, idx) => (
        <div
          key={idx}
          className={`tme-nutrition-analysis__stat-card ${
            idx === 0
              ? "tme-nutrition-analysis__stat-card--green"
              : idx === 1
              ? "tme-nutrition-analysis__stat-card--blue"
              : idx === 2
              ? "tme-nutrition-analysis__stat-card--purple"
              : idx === 3
              ? "tme-nutrition-analysis__stat-card--teal"
              : "tme-nutrition-analysis__stat-card--orange"
          }`}
        >
          <div className="tme-nutrition-analysis__stat-title">{s.label}</div>
          <div className="tme-nutrition-analysis__stat-value">
            {s.value}
            {s.unit ? <span className="tme-nutrition-analysis__stat-unit">{s.unit}</span> : null}
          </div>
          {s.type === "progress" ? (
            <div className="tme-nutrition-analysis__progress">
              <div
                className="tme-nutrition-analysis__progress-fill"
                style={{ width: `${Math.max(0, Math.min(100, Number(s.value)))}%` }}
              />
            </div>
          ) : (
            <div className="tme-nutrition-analysis__stat-subtext">{s.subtext || ""}</div>
          )}
        </div>
      ))}
    </section>
  );
};

export default StatsSummaryRow;


